// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DBxOA","toggleWrap":"styles_toggleWrap__3mmVT","content":"styles_content__1kSn1","selectAreaCode":"styles_selectAreaCode__1yIt6"};